import { CognitoConfiguration } from '@cognitoforms/utils/clientside-configuration';
import { ensureCognitoGlobal } from './globals-management';
import { injectScript } from '@cognitoforms/utils/utils';
import { markRaw } from 'vue';
import type FormDefinition from '../../../../../client/src/framework/form-definition';
import type { AdminFormHandle } from '../../../../../client/src/framework/admin/admin-form-handle';

export type AdminFormNamespace = {
	AdminForm: AdminFormApi;
	TemplateForm: AdminFormApi;
	GenerateForm: AdminFormApi;
};

export type AdminFormApi = {
	getFormDefinition(formId: string, embedContext: string, formJson?: string): Promise<FormDefinition>;
	mount(formId: string, el: HTMLElement | string, embedContext: string, formJson?: string): AdminFormHandle;
	destroy(formId: string): Promise<void>;
	destroyHandle(handle: AdminFormHandle): Promise<void>;
};

export const adminNamespace = 'AdminForm';
export const createFormNamespace = 'CreateForm';

/**
 * Inject the admin form handle
 * @param formId The form id
 * @param apiKey The org's public key
 * @returns A promise
 */
export async function injectAdminFormApi(apiKey: string, targetElement: HTMLElement = null, namespace: string = adminNamespace) {
	return injectScript(`/svc/load-form/script/admin.js?cachehash=${CognitoConfiguration.CacheHash}`, {
		targetElement,
		dataProperties: {
			namespace,
			key: apiKey
		}
	}).then(() => {
		document.querySelectorAll('style.cog-style:not([data-namespace])').forEach(tag => {
			tag.setAttribute('data-namespace', namespace);
		});

		markRaw(window[namespace]);
		const Cognito = ensureCognitoGlobal();
		Cognito.ready('admin-form-api');
	});
}

export function removeAdminFormApi(namespace: string = adminNamespace) {
	// Remove stylesheets injected by form client
	document.querySelectorAll(`style.cog-style[data-namespace="${namespace}"]`).forEach(tag => tag.remove());

	delete window[namespace];
	document.querySelector(`script[data-namespace="${namespace}"]`)?.remove();
}